<template>
  <div>
    <vs-popup
      :active.sync="popup_modal"
      class=""
      :title="$t('system.table_settings')"
    >
      <div class="w-full vx-row">
        <div class="vx-col w-1/2">
          <template v-for="(col, index) in columns">
            <vs-checkbox
              v-if="col.field !== 'id'"
              :key="index"
              :value="!col.hidden"
              class="text-sm mb-1"
              @input="col.hidden = !col.hidden"
            >{{ $t(col.i18n) }}
            </vs-checkbox>
          </template>
        </div>

        <div v-if="false" class="vx-col w-1/2">
          <!-- <vs-checkbox class="text-sm mb-1" v-model="selected_row.id"
            >№</vs-checkbox
          > -->
          <vs-checkbox v-model="selected_row.inn" class="text-sm mb-1"
          >{{ $t("modals.inn") }}
          </vs-checkbox>
          <vs-checkbox v-model="selected_row.region" class="text-sm mb-1"
          >{{ $t("filters.districts") }}
          </vs-checkbox>
          <vs-checkbox v-model="selected_row.company" class="text-sm mb-1"
          >{{ $t("Company") }}
          </vs-checkbox>
          <vs-checkbox v-model="selected_row.date" class="text-sm mb-1"
          >{{ $t("selection_date_table") }}
          </vs-checkbox>
          <vs-checkbox v-model="selected_row.source.number" class="text-sm mb-1"
          >{{ $t("source_number") }}
          </vs-checkbox>
        </div>
        <div v-if="false" class="vx-col w-1/2">
          <vs-checkbox v-model="selected_row.source.name" class="text-sm mb-1"
          >{{ $t("source_name") }}
          </vs-checkbox>
          <vs-checkbox v-model="selected_row.component" class="text-sm mb-1"
          >Ингридиент
          </vs-checkbox>
          <vs-checkbox v-model="selected_row.pdv" class="text-sm mb-1"
          >Норматив
          </vs-checkbox>
          <vs-checkbox v-model="selected_row.value" class="text-sm mb-1"
          >Концентрация
          </vs-checkbox>
          <vs-checkbox v-model="selected_row.excess" class="text-sm mb-1"
          >Превышение
          </vs-checkbox>
          <vs-checkbox v-model="selected_row.actions" class="text-sm mb-1"
          >Действия
          </vs-checkbox>
        </div>
      </div>
    </vs-popup>
    <div class="flex justify-between mb-2">
      <div
        class="vx-col ml-3 w-1/2"
        v-if="
          ($route.name === 'CSAK_Moderation_Air' &&
            checkButtonPermission('csak_d_card_air_moderation_all_action')) ||
          ($route.name === 'CSAK_Moderation_Water' &&
            checkButtonPermission('csak_d_card_water_moder_all_action')) ||
          ($route.name === 'CSAK_Moderation_Ground' &&
            checkButtonPermission('csak_d_card_earth_moder_all_action'))
        "
      >
        <div class="vx-row flex flex-nowrap">
          <div class="m-1 w-auto">
            <vs-button
              color="success"
              icon="icon-check"
              icon-pack="feather"
              type="filled"
              @click="successGroupEmission()"
            >
            </vs-button>
          </div>
          <div class="m-1 w-auto">
            <vs-button
              color="warning"
              icon="icon-x"
              icon-pack="feather"
              type="filled"
              @click="rejectGroupEmission()"
            >
            </vs-button>
          </div>
          <div class="m-1 w-auto">
            <vs-button
              color="danger"
              icon="icon-trash"
              icon-pack="feather"
              type="filled"
              @click="deleteGroupEmission()"
            >
            </vs-button>
          </div>
        </div>
      </div>
      <div class="flex justify-end">
        <!-- <export-csv
          :columns="columns"
          :data="resData"
          class="mr-1"
          name="Факты выбросов"
        >
        </export-csv> -->
        <slot name="export-csv"></slot>
        <vs-button
          icon="icon-settings"
          iconPack="feather"
          size="small"
          @click="popup_modal = true"
        ></vs-button>
      </div>
    </div>

    <vue-good-table
      ref="tableModer"
      :columns="columns"
      :rows="resData"
      :select-options="{
        enabled: true,
        disableSelectInfo: true,
      }"
      :sort-options="{
        enabled: false,
      }"
      class="moderate_table"
      max-height="70vh"
    >
      <div slot="emptystate">{{ $t("no_data") }}</div>
      <template slot="table-column" slot-scope="props" class="uppercase">
        <span>
          {{
            $t(props.column.i18n).toUpperCase() ||
            props.column.label.toUpperCase()
          }}
        </span>
      </template>
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'id'" class="text-nowrap">
          <span>
            {{ props.row.id }}
          </span>
        </span>
        <span
          v-if="props.column.field === 'status.status_name'"
          class="text-nowrap"
        >
          <span>
            <vs-chip :color="props.row.status.status_color">
              {{ props.row.status.status_name }}
            </vs-chip>
          </span>
        </span>
        <span
          v-if="props.column.field === 'source.company_object.inn'"
          class="text-nowrap"
        >
          <span v-if="props.row.source.company_object">
            {{ props.row.source.company_object.inn }}
          </span>
        </span>
        <span v-if="props.column.field === 'region'" class="text-nowrap">
          <span v-if="props.row.source.region && props.row.source.region_name">
            {{ props.row.source.region_name }}
          </span>
        </span>
        <span v-if="props.column.field === 'district_name'" class="text-nowrap">
          <span v-if="props.row.source.district_name">
            {{ props.row.source.district_name }}
          </span>
        </span>
        <span
          v-if="props.column.field === 'source.company_object.title'"
          class="text-nowrap"
        >
          <small v-if="props.row.source.company_object">
            {{ props.row.source.company_object.title }}
          </small>
        </span>
        <span v-if="props.column.field === 'date'">
          <p class="text-nowrap" style="width: 100px">
            {{ props.row.date }}
          </p>
        </span>
        <span v-if="props.column.field === 'source.number'" class="text-nowrap">
          <span>
            {{ props.row.source.number }}
          </span>
        </span>
        <span v-if="props.column.field === 'source.name'" class="text-nowrap">
          <span>
            {{ props.row.source.name }}
          </span>
        </span>
        <span
          v-if="props.column.field === 'component.name'"
          class="text-nowrap"
        >
          <span>
            {{ props.row.component.name }}
          </span>
        </span>
        <span
          v-if="props.column.field === 'component.component_normative.pdv'"
          class="text-nowrap"
        >
          <span v-if="props.row.normative_value">
            {{
              props.row.normative_value.pdv ||
              props.row.fon ||
              props.row.normative_value.pdk ||
              props.row.normative_value.pds ||
              props.row.normative_value.ken
            }}
          </span>
        </span>

        <span v-if="props.column.field === 'active_normative'">
          <span v-if="props.row.source"
          >{{
              props.row.source.normative_is_active ? "Активен" : "Не активен"
            }}
          </span>
        </span>
        <span v-if="props.column.field === 'value'" class="text-nowrap">
          <span>
            {{ props.row.value | formatNumbers }}
          </span>
        </span>
        <span v-if="props.column.field === 'excess'" class="text-nowrap">
          <vs-chip :color="checkExceedingObj(props.row) ? 'danger' : 'success'">
            <span>
              {{ checkExceedingObj(props.row, "value") }}
            </span>
          </vs-chip>
        </span>
        <span v-if="props.column.field === 'excess_status'" class="text-nowrap">
          <vs-chip
            v-if="checkExceedingObj(props.row, 'text')"
            :color="checkExceedingObj(props.row) ? 'danger' : 'success'"
          >
            <span>
              {{ checkExceedingObj(props.row, "text") }}
            </span>
          </vs-chip>
        </span>
        <span v-if="props.column.field === 'actions'" class="text-nowrap">
          <div class="vx-row flex flex-nowrap">
            <div class="m-1 w-auto">
              <vs-button
                color="success"
                icon="icon-check"
                icon-pack="feather"
                type="filled"
                @click="successEmission(props.row)"
                v-if="
                  ($route.name === 'CSAK_Moderation_Air' &&
                    checkButtonPermission(
                      'csak_d_card_air_moder_table_accpet'
                    )) ||
                  ($route.name === 'CSAK_Moderation_Water' &&
                    checkButtonPermission(
                      'csak_d_card_water_moder_table_accpet'
                    )) ||
                  ($route.name === 'CSAK_Moderation_Ground' &&
                    checkButtonPermission(
                      'csak_d_card_earth_moder_table_accpet'
                    ))
                "
              >
              </vs-button>
                  <vs-button
                    v-if="
                  ($route.name === 'CSAK_Moderation_Air' &&
                  checkButtonPermission('csak_d_card_air_moderation_table_d')) || ($route.name === 'CSAK_Moderation_Ground' &&
                  checkButtonPermission('csak_d_card_earth_moder_table_d')) || ($route.name === 'CSAK_Moderation_Water' &&
                  checkButtonPermission('csak_d_card_water_moder_table_d'))
                "
                    class="mt-2"
                    color="#7d33ff"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-arrow-right"
                    @click="$router.push(`/dictionary/settingsObject/edit_objects/${props.row.source.company_object.id}?id=${props.row.source.id}`)"
                  >
              </vs-button>
            </div>
            <div class="m-1 w-auto">
              <vs-button
                color="warning"
                icon="icon-x"
                icon-pack="feather"
                type="filled"
                @click="rejectEmission(props.row)"
                v-if="
                  ($route.name === 'CSAK_Moderation_Air' &&
                    checkButtonPermission(
                      'csak_d_card_air_moder_table_return'
                    )) ||
                  ($route.name === 'CSAK_Moderation_Water' &&
                    checkButtonPermission(
                      'csak_d_card_water_moder_table_return'
                    )) ||
                  ($route.name === 'CSAK_Moderation_Ground' &&
                    checkButtonPermission('csak_d_card_earth_moder_t_return'))
                "
              >
              </vs-button>
            </div>
            <div class="m-1 w-auto">
              <vs-button
                color="danger"
                icon="icon-trash"
                icon-pack="feather"
                @click="deleteEmission(props.row)"
                type="filled"
                v-if="
                  ($route.name === 'CSAK_Moderation_Air' &&
                    checkButtonPermission(
                      'csak_d_card_air_moder_table_delete'
                    )) ||
                  ($route.name === 'CSAK_Moderation_Water' &&
                    checkButtonPermission(
                      'csak_d_card_water_moder_table_delete'
                    )) ||
                  ($route.name === 'CSAK_Moderation_Ground' &&
                    checkButtonPermission('csak_d_card_earth_moder_t_delete'))
                "
              >
              </vs-button>
            </div>
          </div>
        </span>
      </template>
    </vue-good-table>
    <vs-popup
      :active.sync="commentActive"
      class="holamundo"
      :title="$t('comments')"
    >
      <!-- модалка для заполнения коментария  -->
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-textarea
            v-model="formData.description"
            class="w-full"
          ></vs-textarea>
        </div>
        <div class="vx-col mt-2 w-full flex justify-end">
          <vs-popup
            :active.sync="sendPopupActive"
            class="holamundo"
            :title="$t('accepted')"
          >
            <!-- модалка для подтверждения изменения   -->
            <vs-button color="success" class="mr-4" @click="changeEmission"
            >{{ $t("yes") }}
            </vs-button>
            <vs-button color="danger" @click="sendPopupActive = false"
            >{{ $t("no") }}
            </vs-button>
          </vs-popup>
          <vs-button color="primary" @click="sendPopupActive = true">
            {{ $t("save") }}
          </vs-button>
        </div>
      </div>
    </vs-popup>
    <!-- модалка для удаления -->
    <vs-popup
      :active.sync="deletePopupActive"
      class="holamundo"
      :title="$t('accepted')"
    >
      <!-- модалка для подтверждения изменения   -->
      <div class="vx-row flex justify-end">
        <vs-button color="success" class="mr-4" @click="submitDeleteEmission"
        >{{ $t("yes") }}
        </vs-button>
        <vs-button color="danger" @click="deletePopupActive = false"
        >{{ $t("no") }}
        </vs-button>
      </div>
    </vs-popup>

    <!-- ||||||||||||||||||||||||||||||||||||||||| -->
    <!--  модалки для работы с группами (чекбоксы) -->
    <!-- ||||||||||||||||||||||||||||||||||||||||| -->
    <vs-popup
      :active.sync="commentGroupActive"
      class="holamundo"
      :title="$t('comments')"
    >
      <!-- модалка для заполнения коментария  -->
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-input v-model="formDataGroup.description" class="w-full">
          </vs-input>
        </div>
        <div class="vx-col mt-2 w-full flex justify-end">
          <vs-popup
            :active.sync="sendGroupActive"
            class="holamundo"
            :title="$t('accepted')"
          >
            <div class="vx-row flex justify-end">
              <!-- модалка для подтверждения изменения   -->
              <vs-button
                color="success"
                class="mr-4"
                @click="changeGroupEmission"
              >{{ $t("yes") }}
              </vs-button>
              <vs-button color="danger" @click="sendGroupActive = false"
              >{{ $t("no") }}
              </vs-button>
            </div>
          </vs-popup>
          <vs-button color="primary" @click="sendGroupActive = true">
            {{ $t("save") }}
          </vs-button>
        </div>
      </div>
    </vs-popup>
    <!-- модалка для удаления -->
    <vs-popup
      :active.sync="deleteGropupActive"
      class="holamundo"
      :title="$t('delete')"
    >
      <!-- модалка для подтверждения изменения   -->
      <div class="vx-row flex justify-end">
        <vs-button
          color="success"
          class="mr-4"
          @click="submitDeleteGroupEmission"
        >Да
        </vs-button>

        <vs-button color="danger" @click="deleteGropupActive = false"
        >Нет
        </vs-button>
      </div>
    </vs-popup>

    <BigModal ref="bigMd" :modalValue="modalValue" @update="emitData"/>
  </div>
</template>

<script>
import {VueGoodTable} from "vue-good-table";
import BigModal from "./bigModal.vue";

export default {
  props: {
    resData: {
      type: Array,
      required: true,
    },
    hide_excess_status: {type: Boolean, default: false}, // для того что бы скрывать поле СТАТУС ПРИВЫШЕНИЯ
  },
  data() {
    return {
      asasa: false,
      columns: [
        {
          label: "№",
          field: "id",
          hidden: false,
        },
        {
          label: "СТАТУС",
          field: "status.status_name",
          i18n: "modules.analytics.object_info.status",
          hidden: false,
        },
        {
          label: "ИНН",
          i18n: "inn",
          field: "source.company_object.inn",
          hidden: false,
        },
        {
          label: "ОБЛАСТЬ",
          i18n: "filters.region",
          field: "region",
          hidden: false,
        },
        {
          label: "РАЙОН",
          i18n: "modules.analytics.object_info.area",
          field: "district_name",
          hidden: false,
        },
        {
          label: "ПРЕДПРИЯТИЕ",
          i18n: "Company",
          field: "source.company_object.title",
          hidden: false,
        },
        {
          label: "ДАТА ОТБОР",
          i18n: "selection_date_table",
          field: "date",
          hidden: false,
        },
        {
          label: "НОМЕР ИСТОЧНИКА",
          i18n: "source_number",
          field: "source.number",
          hidden: false,
        },
        {
          label: "НАЗВАНИЕ ИСТОЧНИКА",
          i18n: "source_name",
          field: "source.name",
          hidden: false,
        },
        {
          label: "ИНГРИДИЕНТЫ",
          field: "component.name",
          hidden: false,
          i18n: "ingredients",
        },
        {
          label: "НОРМАТИВ",
          i18n: "modules.analytics.object_info.standard",
          field: "component.component_normative.pdv",
          hidden: false,
        },
        {
          label: "СТАТУС ДЕЙСТВИЯ НОРМАТИВА",
          i18n: "status_regulation",
          field: "active_normative",
          hidden: false,
        },
        {
          label: "КОНЦ-ИА",
          field: "value",
          i18n: "actual_emission",
          hidden: false,
        },
        {
          label: "ЗНАЧЕНИЕ ПРЕВЫШЕНИЯ",
          i18n: "filters.znacheniya",
          field: "excess",
          hidden: false,
        },
        {
          label: "СТАТУС ПРЕВЫШЕНИЯ",
          i18n: "status_prev",
          field: "excess_status",
          hidden: false,
        },

        {
          label: "ДЕЙСТВИЯ",
          field: "actions",
          i18n: "modules.backups.actions",
          hidden: false,
          export: false,
        },
      ],
      modalValue: {},
      popup_modal: false, //Модалка для настройки таблицы
      commentActive: false, // модалка
      sendPopupActive: false, // Модалка для подтверждения
      formDataDelete: null, // переменная для эмиссиона который нужно удалить
      deletePopupActive: false, // состояние для модалки подтверждения удаления
      formData: {
        // объект для данных
        data: {}, // объект для данных выброса
        status: {}, // status на который будет изменен выброс
        description: "", // инпут для ввода коментарии в модалке
      },

      // переменные для работы с группами
      commentGroupActive: false,
      formDataGroup: {
        description: null,
        status: null,
      },
      formDataDeleteGroup: null,
      /*
      sendPopupActive
commentActive

      */
      sendGroupActive: false,
      deleteGropupActive: false,

      tableList: [
        "vs-th: Component",
        "vs-tr: Component",
        "vs-td: Component",
        "thread: Slot",
        "tbody: Slot",
        "header: Slot",
      ],
    };
  },
  created() {
    if (this.hide_excess_status) {
      let indexExscessStatus = this.columns.findIndex(
        (e) => e.field === "excess_status"
      );
      this.columns.splice(indexExscessStatus, 1);

      let exscess = this.columns.find((e) => e.field === "value");
      exscess.label = "ФАКТИЧЕСКИЙ ВЫБРОС";
    }
  },
  methods: {
    emitData() {
      this.$emit("update");
    },
    successEmission(value) {
      this.sendPopupActive = true; // Открываю модалку для подтверждения данных
      this.formData = {
        description: "",
        status: {
          // закидваю в formData status и значчение таблицы
          id: 1,
          status_color: "success",
          status_name: "Accepted",
        },
        id: value.id,
      };
    },

    rejectEmission(value) {
      this.modalValue = value;
      this.$refs.bigMd.openBigModal();
    },

    deleteEmission(tr) {
      // Функция для открытия модалки
      this.deletePopupActive = true;
      this.formDataDelete = tr;
    },
    submitDeleteEmission() {
      // Функция для отправки данных в бэк-енд
      let emission_id = new Object();
      emission_id.id = this.formDataDelete.id;
      this.$store
        .dispatch("emissions/deleteDailyPollutionEmissions", emission_id)
        .then((res) => {
          this.deletePopupActive = false;
          this.successNotifySave();
          this.$emit("update"); // emit что бы запросить новые данные для таблицы
        })
        .catch((err) => {
          this.errNotifySave();
        });
    },
    changeEmission() {
      let {id, status, description} = this.formData;
      let changeData = {
        id: Number(id), // Заполняю Id  выброса
        status_id: Number(status.id), // Заполняю Id нового статуса
      };
      if (description) changeData.description = description; // Проверяю указан ли Комментарий
      this.$store
        .dispatch("emissions/changeModerationEmissionStatus", changeData)
        .then((res) => {
          this.$emit("update"); // emit что бы запросить новые данные для таблицы
          this.successNotifySave();
          this.commentActive = false;
          this.sendPopupActive = false;
          this.formData.description = "";
        })
        .catch((error) => {
          this.errNotifySave(error);
        });
    },

    //// функциии для группы

    successGroupEmission() {
      let selectedRows = this.$refs["tableModer"].selectedRows; // выбранные эмишены
      this.sendGroupActive = true; // Открываю модалку для подтверждения данных
      this.formDataGroup = {
        description: "",
        status: {
          // закидваю в formDataGroup status и значчение таблицы
          id: 1,
          status_color: "success",
          status_name: "Accepted",
        },
        ids: selectedRows.map((row) => row.id),
      };
    },
    rejectGroupEmission() {
      let selectedRows = this.$refs["tableModer"].selectedRows; // выбранные эмишены
      this.commentGroupActive = true; // Открываю модалку для оставления комментария
      this.formDataGroup = {
        status: {
          id: 2,
          status_color: "danger",
          status_name: "Rejected",
        },
        ids: selectedRows.map((row) => row.id),
      };
    },
    deleteGroupEmission() {
      let selectedRows = this.$refs["tableModer"].selectedRows; // выбранные эмишены
      // Функция для открытия модалки
      this.deleteGropupActive = true;
      this.formDataDeleteGroup = selectedRows.map((row) => row.id);
    },
    submitDeleteGroupEmission() {
      // Функция для отправки данных в бэк-енд
      let emission_id = {
        ids: this.formDataDeleteGroup,
      };
      this.$store
        .dispatch("emissions/deleteGroupDailyPollutionEmissions", emission_id)
        .then((res) => {
          this.deleteGropupActive = false;
          this.successNotifySave();
          this.$emit("update"); // emit что бы запросить новые данные для таблицы
        })
        .catch((err) => {
          this.errNotifySave();
        });
    },
    changeGroupEmission() {
      let {ids, status, description} = this.formDataGroup;
      let changeData = {
        ids, // Заполняю Id  выброса
        status_id: Number(status.id), // Заполняю Id нового статуса
      };
      changeData.description = description || ""; // Проверяю указан ли Комментарий
      this.$store
        .dispatch("emissions/changeGroupModerationEmissionStatus", changeData)
        .then((res) => {
          this.$emit("update"); // emit что бы запросить новые данные для таблицы
          this.successNotifySave();
          this.commentGroupActive = false;
          this.sendGroupActive = false;
          this.formDataGroup.description = "";
        })
        .catch((error) => {
          this.errNotifySave(error);
        });
    },

    //уведомления
    successNotifySave() {
      this.$vs.notify({
        title: this.$t("saved"),
        text: "",
        color: "success",
      });
    },
    errNotifySave(value) {
      if (typeof value === "string") {
        var errMsg = ": " + value;
      } else {
        var errMsg = "";
      }
      this.$vs.notify({
        title: this.$t("error"),
        text: this.$t("can_not_saved")` ${value}`,
        color: "danger",
      });
    },
  },

  filters: {
    formatNumbers: function (value) {
      if (`${value}`.search("-") === -1) return value / 1;
      return value;
      // return  value.toFixed(`${value}`.split("-").pop());
    },
  },
  components: {
    VueGoodTable,
    BigModal,
  },
};
</script>

<style lang="scss">
.flex-nowrap {
  display: flex;
  flex-wrap: nowrap;
}

@import "~vue-good-table/dist/vue-good-table.css";
.moderate_table .vgt-table {
  overflow-y: auto;
  height: 100px;
}

.moderate_table .vgt-table th {
  position: sticky;
  z-index: 9999;
  top: 0;

  transform: translateY(-2%);
}
</style>
